/* eslint-disable no-unsafe-optional-chaining */
import React, { useEffect, useState } from 'react';
import {
  Flex,
  Modal,
  ModalContent,
  ModalFooter,
  useDisclosure,
  Wrap,
  WrapItem,
} from '@chakra-ui/react';
import Pagination from '@material-ui/lab/Pagination';
import { useFetch } from '../../hooks/useFetch';
import CardTeamsIndicator from '../CardTeamsIndicator';

const ModalTeamIndicator = ({
  id,
  closeOnOverlayClick = true,
  ConfirmButton,
  useSecondaryActions = false,
  onCloseSecondary,
}: any) => {
  const { isOpen, onClose } = useDisclosure();
  const { requestApi: reqApiTeamDashboard, data } = useFetch(
    `/v1/admin/dashboard/teams?institution_id=${id}`,
  );
  useEffect(() => {
    reqApiTeamDashboard('get');
  }, [id]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 1;
  const totalPages = Math.ceil(data?.data?.length / itemsPerPage);

  const handlePageChange = (value: any) => {
    setCurrentPage(value);
  };
  return (
    <Modal
      size="lg"
      isCentered
      closeOnEsc={closeOnOverlayClick}
      closeOnOverlayClick={closeOnOverlayClick}
      isOpen={useSecondaryActions ?? isOpen}
      onClose={useSecondaryActions ? onCloseSecondary : onClose}
    >
      <ModalContent
        maxW="720px"
        borderRadius="20px"
        boxShadow="0px 10px 20px #000000"
        justifyContent="space-between"
      >
        <Wrap spacing="20px">
          {data?.data &&
            (data?.data.length === 1 ? (
              <Wrap spacing="20px">
                {data?.data.slice(currentPage - 1).map((institution: any) => (
                  <WrapItem key={institution.id}>
                    <CardTeamsIndicator
                      data={institution.ratings}
                      institutionName={institution.name}
                    />
                  </WrapItem>
                ))}
              </Wrap>
            ) : (
              <Wrap spacing="20px">
                {data?.data
                  .slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
                  .map((institution: any) => (
                    <WrapItem key={institution.id}>
                      <CardTeamsIndicator
                        data={institution.ratings}
                        institutionName={institution.name}
                      />
                    </WrapItem>
                  ))}
              </Wrap>
            ))}
        </Wrap>
        <Flex justifyContent="flex-end" mr={10}>
          <Pagination
            defaultPage={currentPage}
            count={totalPages}
            page={currentPage}
            onChange={(_, value: number) => handlePageChange(value)}
            color="primary"
            size="small"
          />
        </Flex>

        <ModalFooter mb={5} justifyContent="center">
          {ConfirmButton}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ModalTeamIndicator;
